module.exports = __webpack_public_path__ + "img/pic_tongyongweikong@2x.4c5ffb74.png";